import { EXPAND_PANEL } from '../AC';

const initialState = [];

export default (state = initialState, { type, payload }) => {
	if (type === EXPAND_PANEL)
		return state.includes(payload) ? state.filter(id => id !== payload) : state.concat(payload);
	return state;
};
